import { Box, Button, DialogTitle, ThemeProvider, Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import AddIcon from "@material-ui/icons/Add";
import Table, { TableColumn } from "legacy-components/table/Table";
import Badge from "legacy-components/badge/Badge";
import { Teamcreator } from "./TeamCreator";
import { theme } from "themes/mui";
import { TeamUserAssociator } from "./TeamUserAssociator";
import { AccountDropdown } from "./components/account-dropdown/AccountDropdown";
import {useSelectedAccount} from "./components/account-dropdown/SelectedAccountContext";

export interface TeamJoinerProps {
  refreshUserTeams: any
  userUuid: string
  getAvailableTeams : any
  state : any
  teamList: any
  open: boolean
  toggle: any
  toggleSubscriptionDialog ?: () => void
  subscriptionDialogOpen?:boolean
  newUser: boolean
  accountsState: any
}

export interface Account {
  id: string,
  name: string,
  sourceSystems: any
}

export const TeamJoiner: React.FC<TeamJoinerProps> = ({
  refreshUserTeams,
  userUuid,
  getAvailableTeams,
  state,
  teamList,
  open,
  toggle,
  toggleSubscriptionDialog,
  subscriptionDialogOpen,
  newUser,
  accountsState,
}) => {

  // const { open, toggle } = useDialogProps();  

  const Actions = (data: any) => {
    if (data?.data?.action?.toUpperCase() === "JOIN")
      return (
        <TeamUserAssociator action = "Join" teamId={data?.data?.teamId} userUuid={userUuid} refreshUserTeams={getAvailableTeams}/>
      );
    else
      return (
        <TeamUserAssociator action = "Notify again" teamId={data?.data?.teamId} userUuid={userUuid} refreshUserTeams={getAvailableTeams}/>
          
      );
  };

  const StatusBadge = ({ data }: any) => {
    if (data?.action == "JOIN") return <></>;
    else
      return (
        <Box style={{ justifyContent: "space-between" }}>
          <Badge color="primary" label={"WAITING FOR APPROVAL"} />
        </Box>
      );
  };

    const [data, setData] = useState<Array<any | null>>();
    const [newData, setNewData] = useState<Array<any>>([]);
    const [accounts, setAccounts] = useState<Array<Account>>();
  const { selectedAccount, setSelectedAccount } = useSelectedAccount();

  useEffect(()=> {

    if(state?.value) {
      setData(state?.value)
    }

    if(accountsState?.value) {
      setAccounts(accountsState?.value)
      setSelectedAccount(selectedAccount ?? accountsState?.value?.[0])
    }

  },[accountsState.value, selectedAccount, setSelectedAccount, state.value])


  const handleAccountChange = (event: any) => {
    const selectedAccountId = event.target.value;
    const selectedAccount:Account|undefined = accounts?.find((account) => account.id === selectedAccountId);
    if (selectedAccount)
      {
        setSelectedAccount( selectedAccount);
      }
  };

  useEffect(() => {

    if (!selectedAccount || !data || data.length === 0) {
      return
    }
    if (data) {
      const newData = data.filter((d: any) => d.accountId === selectedAccount?.id);
      setNewData(newData);
    }
  }, [data, selectedAccount]);
  return (
    <>
    {teamList?.length > 0 && (
      <Button
      startIcon={<AddIcon />}
      onClick={getAvailableTeams}
      variant="outlined"
      color="primary"
    >
      <FormattedMessage defaultMessage="Join a Team" />
    </Button>
    )}
      
      
      <Dialog
        open={open}
        title="Join Team"
        onClose={toggle}
        fullWidth={true}
        style={{ padding: "24px 21px" , minWidth: "1001px"}}
        PaperProps={{
          style: {
            width: '1001px',
            maxWidth: '1001%',
            minWidth: '300px' 
          }
        }}
      >
        <ThemeProvider theme={theme}>

            <DialogTitle>
              {teamList?.length == 0 &&  (
                    <section>
                    <Typography variant="h4" align="center" gutterBottom color="primary" style={{color: "#00437B", fontWeight: 600}}>
                      Welcome to Trimble Cloud Console
                    </Typography>
                    <Typography variant="h6" align="center" gutterBottom color="secondary" style={{color: "#019AEB"}}>
                      A one-stop portal for accessing all Trimble Cloud Services
                    </Typography>
                  </section>

              )}

              <Box style={{display: "flex", flexDirection: "row", justifyContent: "space-between", marginTop: "30px", marginLeft: "10px", marginRight: "7px"}}>
              <FormattedMessage defaultMessage="Join a team" />
              <Teamcreator refreshUserTeams={refreshUserTeams} joinOpen={open} joinToggle={toggle} toggleSubscriptionDialog={toggleSubscriptionDialog}
              subscriptionDialogOpen={subscriptionDialogOpen} newUser={newUser} accountsState={accountsState}/>

              </Box>

            </DialogTitle>

        <Box style={{ padding: "0px 30px 30px 30px" }}>
                    <div style={{ marginBottom: "20px"}}>
                      { accounts && accounts.length !== 0 && 
                      <AccountDropdown 
                      accounts={accounts} 
                      selectedAccount={selectedAccount} 
                      handleAccountChange={handleAccountChange} 
                      width="35%"
                      padding="12px 12px"/>
                      }
                      </div>
          <Table
            noRowsText={`There are no existing teams within your account. Create a new team.`}
            rowData={newData}
            height="506px"
            pagination={false}
          >
            <TableColumn
              field="teamName"
              flex={2}
              cellRenderer="Title"
              headerName="Name"
              sortable
              unSortIcon={true}
              filter="agTextColumnFilter"
              filterParams={{
                suppressAndOrCondition: true,
                defaultOption: "contains",
                filterOptions: ["contains"],
              }}
            />
            <TableColumn
              field="relation.userRole"
              flex={2}
              sortable
              unSortIcon={true}
              headerName="Status"
              cellRendererFramework={StatusBadge}
            />

            <TableColumn
              flex={2}
              sortable
              unSortIcon={true}
              headerName="Actions"
              cellRendererFramework={Actions}
            />
          </Table>
          <Box mx={1} style={{marginTop: "20px", display: "flex", flexDirection: "row", justifyContent: "end"}}>
                        <Button onClick={toggle} color="secondary" variant="outlined">Cancel</Button>
                        </Box>
        </Box>
        </ThemeProvider>

      </Dialog>
    </>
  );
};